import type { patchFcConfigInput } from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetFcConfig: undefined;
	usePatchFcConfig: patchFcConfigInput;
}

const FC_CONFIG_SERVICE_KEYS = createReactQueryKeys<KeyTypes>("fc_config", [
	"useGetFcConfig",
	"usePatchFcConfig",
]);

export { FC_CONFIG_SERVICE_KEYS };
